<template>
    <div style="background: #ffffff;width:355px;margin:0 auto 0;">
        <div class="cooperation">
            <div class="li" @click="toCO(1)">
                <img src="@/assets/image/home/home-cooper-1.png" />
                <div class="title">生产资源合作</div>
            </div>
            <div class="li" @click="toCO(2)">
                <img src="@/assets/image/home/home-cooper-2.png" />
                <div class="title">产品合作</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "wapCooperationOpportunities",
        components: {},
        methods:{
           toCO(num){
               if(num == 1){
                   this.$router.push({
                       path:'/cooperationOpportunities?type=1',
                       query:{wapShow:true}
                   });
               }else{
                   this.$router.push({
                       path:'/cooperationOpportunities?type=2',
                       query:{wapShow:true}
                   });
               }

           }
        }
    }
</script>

<style scoped>
    .cooperation{
        width: 355px;
    }
    .cooperation .li{
        width: 355px;
        height: 168px;
        position: relative;
        margin-top:20px;
    }
    .cooperation .li img{
        width: 355px;
    }
    .cooperation .li .title{
        position: absolute;
        width: 100%;
        height: 41px;
        line-height: 40px;
        bottom: 0;
        background: rgba(52, 52, 52, 0.8);
        border-radius: 0px 0px 10px 10px;
        color: #ffffff;
        font-size: 13px;
        text-align: center;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #FFFFFF;
    }
</style>
